.select-breadcrumb {
	// Duplicated to increase specificity !important would not allow us to
	// override the margins for other dividers like in the Simulink view
	:global(.divider.divider.divider) {
		margin: 0;
		padding-inline: 0.5rem;
	}

	:global(.section):is(:hover, :focus) ~ :global(.section),
	:global(.divider):is(:hover, :focus) ~ :global(.section) {
		color: gray !important;
	}
}
